exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".search--wrapper{position:relative}.search--wrapper label{position:absolute;left:.5625rem;top:.5625rem;display:block;width:1rem;height:1rem}.search--wrapper path{fill:#516a7d}.search--wrapper input{padding-left:2rem}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./src/components/Search/Search.scss
// module id = 690
// module chunks = 0